module.exports = __webpack_public_path__ + "static/media/add_stock.311bf748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/add_stock.svg
// module id = 149
// module chunks = 0